import grouperDropdownItems from "./grouper-list-dropdown";

const accordionItems = [
    {id: 1, name: "Cleaning", description: "Description", info: "Some info", items: [], expanded: false, selected: false},
    {id: 2, name: "Measurement", description: "Description", info: "Some info", items: [], expanded: false, selected: false},
    {id: 3, name: "Repair", description: "Description", info: "Some info", items: [], expanded: false, selected: false},
    {id: 4, name: "Electrical Repairs", description: "Description", info: "Some info",
    items: grouperDropdownItems, expanded: false, selected: false}
];

export default accordionItems;
